// Vendors
import { useEffect } from 'react';
import { useErrorBoundary } from 'react-error-boundary';
// Contexts
import { useAppContextConsumerHook } from 'contexts/app.context';
import { useAppGetStateHook } from 'hooks/get-state.hook';
// Constants
import { PAYMENT_POLLING_TIMEOUT } from 'containers/payment/constants/payment.constants';
// Event Handlers
import { PaymentLandingFormPollingHandlers } from 'containers/payment/views/landing/components/form/handlers/payment-landing-form.polling.handlers';

const usePaymentProcessingHook = (): void => {
  const { setCurrentState } = useAppContextConsumerHook();

  const { showBoundary: setError } = useErrorBoundary();

  const {
      handleManagePaymentErrorStatePollingEvent: onError,
      handleManagePaymentSuccessStatePollingEvent: onSuccess,
    } = PaymentLandingFormPollingHandlers({ setError, setCurrentState }),
    { handleGetOnboardingStateEvent } = useAppGetStateHook({
      ...PAYMENT_POLLING_TIMEOUT,
      onError,
      onSuccess,
    });

  useEffect(() => {
    handleGetOnboardingStateEvent();
  }, []);
};

export { usePaymentProcessingHook };
